import { __assign } from "tslib";
import { useContext } from "react";
import createUseContext from "constate";

var GroupProvider = function GroupProvider(context) {
  return __assign({}, context);
};

var _a = createUseContext(GroupProvider),
    Provider = _a.Provider,
    Context = _a.Context;

function useGroupContext() {
  return useContext(Context);
}

export { Provider as GroupProvider, Context as GroupContext, useGroupContext };